module.exports = __webpack_public_path__ + "static/img/6.2af8d2e4.png";